'use strict';exports.__esModule = true;function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var RegexConstructor = function RegexConstructor() {_classCallCheck(this, RegexConstructor);this.
  make = function (strArray) {
    var strRegExp = '';

    for (var _iterator = strArray, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref;if (_isArray) {if (_i >= _iterator.length) break;_ref = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref = _i.value;}var str = _ref;
      strRegExp += str + '|';
    }

    return new RegExp(strRegExp.slice(0, -1), 'i');
  };};exports.default =


new RegexConstructor();module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/regexConstructor.js
// module id = 3146
// module chunks = 0